import React, { useContext, useEffect, useState } from "react";
import { validatorModule } from "../../helpers/helpers";
import { apiRoutes, VW_ROUTES } from "../../constants";
import Axios from "axios";
import DISPLAY_TEXTS from "../../helpers/displayTexts";
import { useToasts } from "react-toast-notifications";
import _ from "lodash";
import { LuEye as EyeOpen } from "react-icons/lu";
import { LuEyeOff as EyeClose } from "react-icons/lu";
import { logout } from "../../helpers/utils";
import { AppContext } from "../../context/AppContext";
import PasswordValidationList from "../../components/PasswordValidationList/PasswordValidationList";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const resetOptions = [
  {
    id: "1",
    title: "Request Reset Email",
    description: "A password reset link will be sent to your email address",
  },
  {
    id: "2",
    title: "Manual Reset",
    description: "You can reset your password directly within the application",
  },
];

const emailValidation = [
  {
    field: "resetEmail",
    isEmail: true,
    isRequired: true,
    fieldName: "Email",
  },
];

const passwordValidation = [
  {
    field: "newPassword",
    isPassword: true,
    fieldName: "Password",
  },
];

const passwordFormValidation = [
  ...passwordValidation,
  {
    field: "confirmPassword",
    isSameAs: {
      field: "newPassword",
      fieldName: "Password",
    },
    isRequired: true,
    fieldName: "Confirm Password",
  },
];

const ResetOptionsComponent = ({ selectedMethod, handleMethodSelect }) => (
  <>
    {resetOptions.map((opt) => (
      <button
        className="custom-radio-button"
        onClick={() => {
          handleMethodSelect(opt?.id);
        }}
      >
        <input
          type="radio"
          className="custom-radio-button-input"
          readOnly
          checked={opt?.id === selectedMethod}
        />
        <div className="ml-3">
          <p className="radio-button-title">{opt?.title}</p>
          <p className="radio-button-description">{opt?.description}</p>
        </div>
      </button>
    ))}
  </>
);

const PasswordResetEmailForm = ({ mail, handleChange, errorState }) => (
  <div>
    <div
      className={`form-group position-relative col-md-8 error-l-75 px-0 mb-4 ${
        errorState ? "hasValidationError" : ""
      }`}
    >
      <label>Please enter your email id to get password reset link:</label>
      <input
        type="text"
        value={mail}
        name="email"
        className="form-control"
        placeholder="Email"
        onChange={(e) => handleChange(e.target?.value)}
      />
      <span className="validation-error-message">
        {errorState ? errorState : ""}
      </span>
    </div>
    <div className="info-text flex-column align-items-start mt-2">
      <b className="mt-4 mb-2">Note:</b>
      <p>
        A secure link to reset your password will be sent to the email address
        you provided. Please check your inbox for further instructions.
      </p>
    </div>
  </div>
);

const PasswordResetForm = ({
  newPasswordValue,
  handleNewPasswordChange,
  newPassWordErrorState,
  confirmPasswordValue,
  handleConfirmPasswordChange,
  confirmPasswordErrorState,
  editStarted,
}) => {
  const [showPassWord, setShowPassword] = useState(false);
  const handleShowPassword = () => {
    setShowPassword((currState) => !currState);
  };

  return (
    <div>
      <div
        className={`form-group position-relative col-md-9 error-l-75 px-0 mb-4 ${
          editStarted &&
          newPassWordErrorState &&
          newPassWordErrorState?.find((validateItem) => validateItem?.isError)
            ? "hasValidationError"
            : ""
        }`}
      >
        <label>New Password</label>
        <div className="position-relative">
          <input
            value={newPasswordValue}
            name="newPassword"
            className="form-control"
            placeholder="New Password"
            onChange={(e) => handleNewPasswordChange(e.target?.value)}
            type={showPassWord ? "text" : "password"}
          />
          <span className="input-tail-icon" onClick={handleShowPassword}>
            {showPassWord ? <EyeOpen /> : <EyeClose />}
          </span>
        </div>
        <div className="mt-3  mx-2">
          <PasswordValidationList errorState={newPassWordErrorState} />
        </div>
      </div>
      <div
        className={`form-group position-relative col-md-9 error-l-75 px-0 mb-2 ${
          confirmPasswordErrorState ? "hasValidationError" : ""
        }`}
      >
        <label>Confirm Password</label>
        <input
          value={confirmPasswordValue}
          name="confirmPassword"
          className="form-control"
          placeholder="Confirm Password"
          type="password"
          onChange={(e) => handleConfirmPasswordChange(e.target?.value)}
          onPaste={(e) => e.preventDefault()}
          onDrop={(e) => e.preventDefault()}
          autoComplete="off"
        />
        <span className="validation-error-message">
          {confirmPasswordErrorState ? confirmPasswordErrorState : ""}
        </span>
      </div>
    </div>
  );
};
const UserPasswordResetModal = ({ userId, onCloseCallback }) => {
  const history = useHistory();
  const { currentUser } = useContext(AppContext);
  const { addToast } = useToasts();
  const [isLoaderActive, setLoaderActive] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [confirmedMethod, setConfirmedMethod] = useState(null);
  const [resetEmail, setResetEmail] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [errorState, setErrorState] = useState(null);
  const [editStarted, setEditStarted] = useState(false);

  const token = localStorage.getItem("access_token");
  const config = {
    headers: {
      Authorization: `JWT ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const handleNextCallback = () => {
    if (selectedMethod == null) return;
    setConfirmedMethod(selectedMethod);
  };

  const handleEmailSubmit = (emailValue) => {
    setLoaderActive(true);
    const url = new URL(`${apiRoutes.resetPassword}/${userId}/email`);
    const formData = new FormData();
    formData.append("email", emailValue);
    Axios.post(url, formData, config)
      .then((res) => {
        addToast(
          res?.data?.data?.message ??
            DISPLAY_TEXTS.RESET_PASSWORD_SUCCESSFULL_MAIL,
          { appearance: "success" }
        );
      })
      .catch((err) => {
        addToast(
          err?.response?.data?.errors[0]?.detail ??
            DISPLAY_TEXTS.RESET_PASSWORD_FAILED_MAIL,
          { appearance: "warning" }
        );
      })
      .finally(() => {
        handleModalClose();
      });
  };

  const handleLogoutUser = () => {
    logout();
    history.push(VW_ROUTES.LOGIN);
  };

  const handleMaunualPasswordSubmit = (newPassword, confirmPassword) => {
    setLoaderActive(true);
    const url = new URL(`${apiRoutes.resetPassword}/${userId}/manually`);
    Axios.post(
      url,
      { new_password1: newPassword, new_password2: confirmPassword },
      config
    )
      .then((res) => {
        addToast(
          res?.data?.data?.message ??
            DISPLAY_TEXTS.RESET_PASSWORD_SUCCESSFULL_MANUAL,
          { appearance: "success" }
        );
        if (currentUser?.user_id === userId) {
          handleLogoutUser();
        } else {
          handleModalClose();
        }
      })
      .catch((err) => {
        addToast(
          err?.response?.data?.errors?.[0]?.detail ??
            DISPLAY_TEXTS.RESET_PASSWORD_FAILED_MANUAL,
          { appearance: "warning" }
        );
      })
      .finally(() => {
        setLoaderActive(false);
      });
  };

  const handlePasswordValidation = (isForm = false) => {
    const errorValidation = validatorModule(
      {
        newPassword,
        ...(isForm ? { confirmPassword } : {}),
      },
      isForm ? passwordFormValidation : passwordValidation
    );
    setErrorState(errorValidation);
    if (
      errorValidation?.newPassword?.find(
        (validateItem) => validateItem?.isError
      ) ||
      _.size(errorValidation?.confirmPassword)
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmitCallback = () => {
    if (confirmedMethod == null) return;
    if (confirmedMethod == resetOptions[0].id) {
      const errorValidation = validatorModule(
        {
          resetEmail: resetEmail,
        },
        emailValidation
      );
      if (errorValidation && _.size(errorValidation?.resetEmail)) {
        setErrorState(errorValidation);
      } else {
        setErrorState(null);
        handleEmailSubmit(resetEmail);
      }
    } else if (confirmedMethod == resetOptions[1].id) {
      if (handlePasswordValidation(true)) {
        handleMaunualPasswordSubmit(newPassword, confirmPassword);
      }
    }
  };

  const handleMethodSelect = (method) => {
    setSelectedMethod(method);
  };

  const handleResetModalState = () => {
    setLoaderActive(false);
    setSelectedMethod(null);
    setConfirmedMethod(null);
    setConfirmPassword(null);
    setNewPassword(null);
    setResetEmail(null);
    setErrorState(null);
  };

  const handleModalClose = () => {
    handleResetModalState();
    onCloseCallback();
  };

  const handleResetEmailChange = (emailText) => setResetEmail(emailText);
  const handleNewPasswordChange = (newPasswordText) =>
    setNewPassword(newPasswordText);
  const handleConfirmPasswordChange = (confirmPasswordText) =>
    setConfirmPassword(confirmPasswordText);

  useEffect(() => {
    handleResetModalState();
  }, [userId]);

  useEffect(() => {
    if (confirmedMethod !== resetOptions[1].id) return;
    if (!editStarted && newPassword?.length) {
      setEditStarted(true);
    }
    handlePasswordValidation();
  }, [newPassword, editStarted, confirmedMethod]);

  const getPasswordErrorStatus = () =>
    errorState?.newPassword?.find((validateItem) => validateItem?.isError);

  return (
    <>
      <div className="modal-body" style={{ minHeight: "22rem" }}>
        {confirmedMethod === null ? (
          <ResetOptionsComponent
            selectedMethod={selectedMethod}
            handleMethodSelect={handleMethodSelect}
          />
        ) : confirmedMethod == resetOptions[1].id ? (
          <PasswordResetForm
            newPasswordValue={newPassword}
            handleNewPasswordChange={handleNewPasswordChange}
            newPassWordErrorState={errorState?.newPassword}
            confirmPasswordValue={confirmPassword}
            handleConfirmPasswordChange={handleConfirmPasswordChange}
            confirmPasswordErrorState={errorState?.confirmPassword}
            editStarted={editStarted}
          />
        ) : (
          <PasswordResetEmailForm
            errorState={errorState?.resetEmail}
            handleChange={handleResetEmailChange}
            mail={resetEmail}
          />
        )}
      </div>
      <div className="modal-footer mt-2">
        {confirmedMethod !== null && (
          <button
            type="button"
            className="btn btn-primary"
            disabled={isLoaderActive}
            onClick={handleModalClose}
          >
            Cancel
          </button>
        )}
        <button
          type="button"
          disabled={
            isLoaderActive || getPasswordErrorStatus() || selectedMethod == null
          }
          onClick={() =>
            confirmedMethod !== null
              ? handleSubmitCallback()
              : handleNextCallback()
          }
          className="btn btn-secondary position-relative"
        >
          {confirmedMethod !== null ? "Submit" : "Next"}
          {isLoaderActive && (
            <span className="button-loader-container">
              <div
                className="spinner-border spinner-border-sm ml-1 text-white"
                role="status"
              ></div>
            </span>
          )}
        </button>
      </div>
    </>
  );
};

export default UserPasswordResetModal;
